import cookies from "./Services/cookies";
import {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import styles from './Portal.module.css';
import CustomerMessage from "./Customer-Message/CustomerMessage";
import WaitingAd from "./Waiting-Ad/WaitingAd";
import Button from "../Component/Button/Button";
import HttpService from "./Services/HttpService";
import {toast} from "react-toastify";
import {completeLoading, startLoading} from "../Component/Loader/loadingBar";
import Warnings from "./Warnings/Warnings";


function Portal() {
    const location = useLocation();
    const navigate = useNavigate();
    const cookie = cookies();

    const menus = [
        {
            id: 1,
            name: "آگهی انتظار",
            hash: "ads",
            widget: <WaitingAd />,
            icon: (
                <svg width="20" height="23" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M14.5 8.39795L5.5 3.20795M1.27 5.95795L10 11.0079L18.73 5.95795M10 21.0779V10.9979M19 14.9979V6.99795C18.9996 6.64722 18.9071 6.30276 18.7315 5.99911C18.556 5.69546 18.3037 5.44331 18 5.26795L11 1.26795C10.696 1.09241 10.3511 1 10 1C9.64893 1 9.30404 1.09241 9 1.26795L2 5.26795C1.69626 5.44331 1.44398 5.69546 1.26846 5.99911C1.09294 6.30276 1.00036 6.64722 1 6.99795V14.9979C1.00036 15.3487 1.09294 15.6931 1.26846 15.9968C1.44398 16.3004 1.69626 16.5526 2 16.7279L9 20.7279C9.30404 20.9035 9.64893 20.9959 10 20.9959C10.3511 20.9959 10.696 20.9035 11 20.7279L18 16.7279C18.3037 16.5526 18.556 16.3004 18.7315 15.9968C18.9071 15.6931 18.9996 15.3487 19 14.9979Z"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            ),
        },
        {
            id: 2,
            name: "پیغام مشتری",
            hash: "messages",
            widget: <CustomerMessage />,
            icon: (
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M15 6.99938V11.9994C15 12.795 15.3161 13.5581 15.8787 14.1207C16.4413 14.6833 17.2044 14.9994 18 14.9994C18.7957 14.9994 19.5587 14.6833 20.1213 14.1207C20.6839 13.5581 21 12.795 21 11.9994V10.9994C20.9999 8.74241 20.2362 6.55186 18.8333 4.78391C17.4303 3.01596 15.4706 1.7746 13.2726 1.26168C11.0747 0.748749 8.76794 0.994421 6.72736 1.95875C4.68677 2.92307 3.03241 4.54933 2.03327 6.5731C1.03413 8.59687 0.748975 10.8991 1.22418 13.1055C1.69938 15.3119 2.90699 17.2926 4.65064 18.7256C6.39429 20.1587 8.57144 20.9597 10.8281 20.9985C13.0847 21.0373 15.2881 20.3116 17.08 18.9394M15 10.9994C15 13.2085 13.2092 14.9994 11 14.9994C8.79087 14.9994 7.00001 13.2085 7.00001 10.9994C7.00001 8.79024 8.79087 6.99938 11 6.99938C13.2092 6.99938 15 8.79024 15 10.9994Z"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            ),
        },
        {
            id: 3,
            name: "گزارشات مشتری",
            hash: "warnings",
            widget: <Warnings/>,
            icon: (
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
                          stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 9v4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M12 17h.01" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"
                          strokeLinejoin="round"/>
                </svg>
            ),
        },
    ];

    const [activeMenu, setActiveMenu] = useState(menus[0]);
    const [userInfo, setUserInfo] = useState({});

    //userInfo
    useEffect(() => {
        HttpService.get(`User/Userinfo`)
            .then(res => {
                setUserInfo(res.data);
            })
            .catch(err => {
                toast.error('خطا در دریافت اطلاعات کاربر');
            })
    }, []);

    // بررسی لاگین
    useEffect(() => {
        if (!cookie.has("token") && location.pathname !== "/portal/login") {
            navigate("/login");
        }
    }, [cookie, location, navigate]);

    // بررسی hash در URL
    useEffect(() => {
        const hash = decodeURIComponent(window.location.hash.replace("#", ""));
        const foundMenu = menus.find((m) => m.hash === hash);
        if (foundMenu) {
            setActiveMenu(foundMenu);
        }
    }, []);


    // در صورت کلیک روی منو، hash را هم تغییر بده
    const handleMenuClick = (menu) => {
        startLoading();
        setActiveMenu(menu);
        window.location.hash = menu.hash;
        completeLoading();
    };

    const onSendMessageToBus = () => {};
    const onExitUser = () => {
        cookie.remove("token");
        navigate("/login");
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.buttons_header}>
                    <Button
                        text="خروج"
                        onClick={onExitUser}
                        icon={
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M7 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H7M14 15L19 10M19 10L14 5M19 10H7"
                                    stroke="#F2F2F2"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        }
                    />
                    <Button
                        text="پیام به مدیریت"
                        onClick={onSendMessageToBus}
                        icon={
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19 9.50003C19.0034 10.8199 18.6951 12.1219 18.1 13.3C17.3944 14.7118 16.3098 15.8992 14.9674 16.7293C13.6251 17.5594 12.0782 17.9994 10.5 18C9.18013 18.0035 7.87812 17.6951 6.7 17.1L1 19L2.9 13.3C2.30493 12.1219 1.99656 10.8199 2 9.50003C2.00061 7.92179 2.44061 6.37488 3.27072 5.03258C4.10083 3.69028 5.28825 2.6056 6.7 1.90003C7.87812 1.30496 9.18013 0.996587 10.5 1.00003H11C13.0843 1.11502 15.053 1.99479 16.5291 3.47089C18.0052 4.94699 18.885 6.91568 19 9.00003V9.50003Z"
                                    stroke="#F2F2F2"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        }
                    />
                </div>

                <div className={styles.profile}>
                    <h3>پشتیبان | {userInfo?.name ?? "نام کاربر"}</h3>
                    <div className={styles.imageContainer}>
                        <i className="fa fa-user"></i>
                    </div>
                </div>
            </div>

            <div className={styles.container_body}>
                <div className={styles.nav_body}>{activeMenu.widget}</div>
                <div
                    className={`${styles.nav_menu}`}
                >
                    <ul>
                        {menus.map((menu) => (
                            <li
                                key={menu.id}
                                style={{
                                    borderBottom:
                                        activeMenu.id === menu.id
                                            ? "1px solid var(--color-a)"
                                            : "1px solid var(--color-b)",
                                    color:
                                        activeMenu.id === menu.id
                                            ? "var(--color-a)"
                                            : "var(--color-b)",
                                }}
                                onClick={() => handleMenuClick(menu)}
                            >
                                {menu.icon}
                                <p
                                    style={{
                                        color:
                                            activeMenu.id === menu.id
                                                ? "var(--color-a)"
                                                : "var(--color-b)",
                                    }}
                                >
                                    {menu.name}
                                </p>
                            </li>
                        ))}
                    </ul>
                </div>

            </div>
        </div>
    );
}

export default Portal;
